import React from 'react';
import RegistrationContainer from '../../containers/register';

const RegistrationScreen = ({ registrationStep = 1 }) => {
  return <RegistrationContainer registrationStep={registrationStep} />;
};

export default RegistrationScreen;
